import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      prefijos: 'maestros/prefijos/getAll'
    })
  },
  methods: {
    separarTelefono (telefono, codigoPrefijoTelefonicoId) {
      if (codigoPrefijoTelefonicoId == null) {
        codigoPrefijoTelefonicoId = this.prefijos.find(x => x.codigo == '+34').id
      }
      if (telefono == null) {
        return {
          prefijo: codigoPrefijoTelefonicoId,
          numTelefono: null
        }
      }
      let prefijo = this.prefijos.find(x => x.id === codigoPrefijoTelefonicoId).codigo
      let numTelefono = telefono.substring(prefijo.length)
      return {
        prefijo: codigoPrefijoTelefonicoId,
        numTelefono
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/prefijos.js